import React from 'react';
import { ArrowRight, Target } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const CTASection = () => {
  const { isAuthenticated, setShowAuthModal } = useAuth();

  const handleGetAccess = (e) => {
    e.preventDefault();
    if (isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      setShowAuthModal('signup');
    }
  };

  return (
    <section className="py-24 px-6 relative overflow-hidden bg-[#0f0f0f]">
      {/* Background */}
      <div 
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at 50% 100%, rgba(255,255,255,0.05) 0%, transparent 50%),
                       #0f0f0f`
        }}
      />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8">
          <Target size={16} className="text-emerald-400" />
          <span className="text-sm font-medium text-white/80">Focus on revenue, not posting</span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
          Ready to Scale
          <br />
          <span className="text-white/50">Your Social Presence?</span>
        </h2>

        {/* Description */}
        <p className="text-lg text-[#737373] max-w-2xl mx-auto mb-10">
          Stop worrying about what to post every day. Let us handle the content distribution 
          while you focus on driving traffic, promoting offers, and making money.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={handleGetAccess}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-[#0a0a0a] font-semibold hover:bg-white/90 hover:scale-[1.02] transition-all duration-200"
          >
            🚀 Get Access Now
            <ArrowRight size={18} />
          </button>
          <a 
            href="/#content-library" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-all duration-200"
          >
            Browse Content Library
          </a>
        </div>

        {/* Trust Text */}
        <p className="mt-8 text-sm text-[#737373]">
          30 days of posting · Multiple content types · Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default CTASection;
